import {
  RadarChart,
  PolarGrid,
  PolarAngleAxis as RechartsPolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  colors,
  formatXAxis,
  formatYAxis,
  IAiChart,
  IRadarChart,
} from "./chartConfig";
import { customTokens } from "../../theme/theme";
import { ComponentType, FC } from "react";

const PolarAngleAxis =
  RechartsPolarAngleAxis as unknown as ComponentType<any>;

const AiRadarChart: FC<IAiChart> = ({ config, chartData }) => {
  const { data } = config as IRadarChart;

  const categoriesField = data.categories.field;
  const valuesField = data.values.field;
  const seriesKey = data.series;

  // If we have series, pivot data into multiple y-fields
  let transformedData = chartData;
  let seriesValues: string[] = [];

  if (seriesKey) {
    seriesValues = Array.from(new Set(chartData.map((d) => d[seriesKey])));

    transformedData = chartData.reduce((acc: any[], curr) => {
      const existing = acc.find(
        (item) => item[categoriesField] === curr[categoriesField]
      );

      if (existing) {
        existing[curr[seriesKey]] = curr[valuesField];
      } else {
        acc.push({
          [categoriesField]: curr[categoriesField],
          [curr[seriesKey]]: curr[valuesField],
        });
      }

      return acc;
    }, []);
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <RadarChart cx="50%" cy="50%" outerRadius="70%" data={transformedData}>
        <PolarGrid />

        <PolarAngleAxis
          dataKey={categoriesField}
          tick={{
            fill: customTokens.fontDarkGrayBody,
          }}
          tickFormatter={(v: any) => formatXAxis(v)}
        />

        <PolarRadiusAxis
          tickFormatter={formatYAxis}
          tick={{
            fill: customTokens.fontDarkGrayBody,
            fontSize: 12,
            dx: 6,
            dy: 10,
          }}
          angle={90}
        />

        {seriesValues.length > 0 ? (
          seriesValues.map((s, idx) => (
            <Radar
              key={s}
              name={s}
              dataKey={s}
              stroke={colors[idx % colors.length]}
              fill={colors[idx % colors.length]}
              fillOpacity={0.6}
            />
          ))
        ) : (
          <Radar
            name={data.values.label}
            dataKey={valuesField}
            stroke={customTokens.UNFCCCBrandGraphLevel1}
            fill={customTokens.UNFCCCBrandGraphLevel1}
            fillOpacity={0.6}
          />
        )}

        <Tooltip formatter={(value) => formatYAxis(value)} />

        <Legend />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default AiRadarChart;
